<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <form class="form-inline">
          <div class="form-group">
            <label for="f1">幸运用户数量</label>
            <input type="number" v-model="form.number" class="form-control">
          </div>
          <div class="form-group">
            <label for="f2">礼物</label>
            <input type="text" v-model="form.present" class="form-control">
          </div>
          <button type="button" @click="click(submit)($event)" class="btn btn-success">保存</button>
        </form>
      </div>
      <div class="col-xs-6">
        <div class="alert alert-info">
        幸运用户数量：<span class="text-danger">{{data.present.number}}</span>
        礼物：<span class="text-danger">{{data.present.present}}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4">
        <form class="form-inline">
          <div class="form-group">
            <input type="text" v-model="search.alias" class="form-control" placeholder="团号">
            <select class="form-control" v-model="search.catalog">
              <option value="">路线类型</option>
              <option value="CW">CW</option>
              <option value="ST">ST</option>
              <option value="CE">CE</option>
            </select>
          </div>
          <a v-link="'/feedback/?alias='+search.alias+'&catalog='+search.catalog+'&leaderId='+search.leaderId" class="btn btn-success">搜索</a>
        </form>
      </div>
      <div class="col-xs-6"></div>
      <div class="col-xs-2 text-right">
        <a v-link="'/feedback/member'" class="btn btn-primary">反馈列表</a>
      </div>
    </div>
    <div class="row">
      <form id="exportForm" class="form-inline" method="get">
        <div class="form-group">
          <label>开始日期</label>
          <input type="text" name="start" v-model="excel.start" placeholder="日期格式：YYYY-mm-dd">
        </div>
        <div class="form-group">
          <label for="f1">结束日期</label>
          <input type="text" name="end" v-model="excel.end" placeholder="日期格式：YYYY-mm-dd">
        </div>
        <button type="button" @click="exportCW()" class="btn btn-info">导出CW数据</button>
        <button type="button" @click="exportST()" class="btn btn-info">导出ST数据</button>
      </form>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>团号</th>
          <th>旅行名称</th>
          <th>模板名称</th>
          <th>报名人数</th>
          <th>反馈人数</th>
          <th>反馈率</th>
          <th>结束时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data.list.data">
          <td class="primary">{{item.alias}}</td>
          <td><a v-link="'/feedback/trip/member?tripAlias=' + item.alias">{{item.abbreviation}}({{item.start}})</a></td>
          <td>{{item.name}}</td>
          <td>{{item.totalNum}}</td>
          <td>{{item.feedbackNum}}</td>
          <td class="text-danger">{{((item.feedbackNum / item.totalNum) * 100 || 0) | toFixed  2 }}%</td>
          <td>{{item.lastDate.slice(0, 10)}}</td>
          <td><a v-link="'/feedback/' + item.tripId" class="btn btn-xs btn-success">详情</a></td>
        </tr>
      </tbody>
    </table>
    <nav class="text-center">
      <ul class="pagination">
        <li v-for="item in data.list.last_page" track-by="$index" :class="{active: data.list.current_page == $index + 1}">
          <a v-link="'/feedback/?page='+($index + 1)+'&alias='+search.alias+'&catalog='+search.catalog+'&leaderId='+search.leaderId">{{$index + 1}}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import $ from 'jquery'
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  export default {
    data () {
      return {
        exportAction: '',
        search: {
          alias: '',
          catalog: '',
          leaderId: this.$route.query.leaderId ? this.$route.query.leaderId : ''
        },
        data: {
          list: [],
          present: {}
        },
        excel: {
          start: null,
          end: null
        },
        form: {
          number: '',
          present: ''
        },
        config
      }
    },
    methods: {
      fetchList () {
        return this.$http.get(`${config.apiWe}/product/feedback/analyze`, {
          page: this.$route.query.page || 1,
          alias: this.$route.query.alias,
          leaderId: this.$route.query.leaderId,
          catalog: this.$route.query.catalog
        })
          .then(({data}) => {
            this.data = data
          })
      },
      submit () {
        return this.$http.put(`${config.apiWe}/product/feedback/present`, this.form)
          .then(() => {
            Object.assign(this.data.present, this.form)
          })
      },
      exportCW () {
        $('#exportForm').attr('action', config.apiWe + '/product/feedback/exportCW')
        $('#exportForm').submit()
      },
      exportST () {
        $('#exportForm').attr('action', config.apiWe + '/product/feedback/exportST')
        $('#exportForm').submit()
      },
      click: utils.click
    },
    route: {
      data () {
        return this.fetchList()
      }
    }
  }
</script>

<style scoped>
  .form-inline {
    margin-bottom: 20px;
  }
</style>



/** WEBPACK FOOTER **
 ** List.vue?61f82c2c
 **/